import { properties2 } from "../../data/properties";
import { BaseURL } from "../../APIs/APIUrls";
import { Link } from "react-router-dom";
import React from "react";

export default function LeatestProperties() {

  const [latestProperties, setLatestProperties] = React.useState([]);

  React.useEffect(() => {

    let latestproeprties = localStorage.getItem("TopandLatest_8_PropertiesforWeb");
    if (latestproeprties) {
      try {
        const parsed = JSON.parse(latestproeprties);
        if (Array.isArray(parsed)) {
          setLatestProperties(parsed);
          return;
        }
      } catch (error) {
        console.error("Error parsing latest properties from localStorage:", error);
      }
    }
  }, []);

  const returnCardImage = (propertyid, PropertyImages) => {
    if (!PropertyImages || !PropertyImages.length) {
      return "https://via.placeholder.com/615x405?text=No+Image";
    }
    const cardImage = PropertyImages.filter(x => x.IsCard === true && x.PropertyId == propertyid)?.[0]?.ImageURL;
    return cardImage ? BaseURL + cardImage : "https://via.placeholder.com/615x405?text=No+Image";
  }

  return (
    <>
      {" "}
      <h5 className="fw-6 title">Latest Propeties</h5>
      <ul>
        {latestProperties.map((property, index) => (
          <li key={index} className="latest-property-item">
            <Link
              to={`/property-details/${property.AutoGeneratedURL}`}
              className="images-style"
            >
              <img
                data-src={returnCardImage(property.PropertyId, property._lstPropertyImages)}
                alt={property?.PropertyTitle}
                src={returnCardImage(property.PropertyId, property._lstPropertyImages)}
                width={615}
                height={405}
                loading="lazy"
              />
            </Link>
            <div className="content">
              <div className="text-capitalize text-btn">
                <Link
                  to={`/property-details/${property.AutoGeneratedURL}`}
                  className="link"
                >
                  {property.PropertyGeneratedId} &nbsp;&nbsp;|&nbsp;&nbsp;{property.PropertyFor} &nbsp;&nbsp;|&nbsp;&nbsp; {property.PropertyTitle}
                </Link>
              </div>
              <ul className="meta-list mt-6">
                {
                  property.NoofRoom && (
                    <>
                      <li className="item">
                        <i className="icon icon-bed" />
                        <span className="text-variant-1">Beds:</span>
                        <span className="fw-6">{property.NoofRoom}</span>
                      </li>
                    </>
                  )
                }
                {
                  property.NoofWashroom && (
                    <li className="item">
                      <i className="icon icon-bath" />
                      <span className="text-variant-1">Baths:</span>
                      <span className="fw-6">{property.NoofWashroom}</span>
                    </li>

                  )
                }
                {
                  property.PropertyFor === "Sell" && (
                    <li className="item">
                      <i className="icon icon-sqft" />
                      <span className="fw-6">Land Area: {property.LandSize}</span>
                      <span className="text-variant-1">{property.LandSizeUnit}</span>

                    </li>
                  )
                }
                {
                  (property.PropertyFor === "Rent" || property.PropertyFor === "PG") && property.CarpetArea ?
                    (property.PropertyFor === "Rent" || property.PropertyFor === "PG") && property.CarpetArea && (
                      <li className="item">
                        <i className="icon icon-sqft" />

                        <span className="fw-6">Carpet Area: {property.CarpetArea}</span>
                        <span className="text-variant-1">{property.CarpetAreaUnitSize}</span>
                      </li>
                    ) :
                    (property.PropertyFor === "Rent" || property.PropertyFor === "PG") && property.BuiltUpArea ?
                      (property.PropertyFor === "Rent" || property.PropertyFor === "PG") && property.BuiltUpArea && (
                        <li className="item">
                          <i className="icon icon-sqft" />
                          <span className="fw-6">Constructed Area: {property.BuiltUpArea}</span>
                          <span className="text-variant-1">{property.BuiltUpAreaUnitSize}</span>
                        </li>
                      ) :
                      (property.PropertyFor === "Rent" || property.PropertyFor === "PG") && property.SuperArea ?
                        (property.PropertyFor === "Rent" || property.PropertyFor === "PG") && property.SuperArea && (
                          <li className="item">
                            <i className="icon icon-sqft" />
                            <span className="fw-6">Constructed Area: {property.SuperArea}</span>
                            <span className="text-variant-1">{property.SuperAreaUnitSize}</span>
                          </li>
                        ) : null
                }

              </ul>
              <div className="mt-10 text-btn">
                {
                  property.PropertyFor == "Rent" || property.PropertyFor == "PG"
                    ? `₹ ${new Intl.NumberFormat('en-IN').format(property.RentPerMonth)} /Month`
                    :
                    property.PropertyFor == "Sell" ?
                      `₹ ${new Intl.NumberFormat('en-IN').format(property.ExpectedPrice)} /${property.ExpectedPricePerUnit}`
                      : null
                }
              </div>
            </div>
          </li>
        ))}
      </ul>
    </>
  );
}
